import { createContext, ReactNode, useState } from "react";

const ProductContext = createContext({
  categoryPageRecommendationData: {},
  updateCategoryPageRecommendationData: (el) => {},
});

export const ProductContextProvider = ({ children }: { children: ReactNode }) => {
  const [categoryPageRecommendationData, setCategoryPageRecommendationData] = useState({});

  const updateCategoryPageRecommendationData = (el) => setCategoryPageRecommendationData(el);

  return (
    <ProductContext.Provider value={{ categoryPageRecommendationData, updateCategoryPageRecommendationData }}>
      {children}
    </ProductContext.Provider>
  );
};

export default ProductContext;
